export function resolveDashboardHeaderSlots(defaultSlots, slots = {}) {
    return {
        ...defaultSlots,
        ...slots,
    }
}
